const destructure = (typeServices) => {
  return typeServices.map((service) => service?.id)
}

export default destructure
